var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('animate-x',{staticClass:"absolute w-full",attrs:{"keyframes":[
    { // 0%
      translateX: 0,
      translateY: 0,
      rotate: 0,
      scale: 1,
      opacity: 1,
      duration: 0
    },
    {
      translateX: 0,
      translateY: -_vm.windowHeight,
      rotate: 0,
      scale: 1,
      opacity: 1,
      duration: 500
    }
  ],"triggerAt":1305,"deltaYcounter":_vm.deltaYcounter}},[_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + _vm.sky1)})},[_c('div',{staticClass:"text-center absolute w-full",staticStyle:{"top":"3%"},style:({transform: ("scale(" + _vm.scaleFactorTxt + ")")})},[_c('h1',{staticStyle:{"color":"#001c26","font-size":"30px","font-weight":"400","margin-bottom":"0px"}},[_vm._v("Sustainability at Network Rail")]),_c('h2',{staticStyle:{"color":"#3fb498","font-size":"20px","font-weight":"400"}},[_vm._v("PART ONE")])])])]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -75,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + _vm.hills2)})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -50,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover first-train animation-config relative",style:({'background-image': ("url(" + _vm.train3)})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -60,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + _vm.hills4)})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -30,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover second-train animation-config relative",style:({'background-image': ("url(" + _vm.train5)})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -30,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + _vm.viaduct6)})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -80,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + _vm.hills7)})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -80,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover third-train animation-config relative",style:({'background-image': ("url(" + _vm.train8)})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -150,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + _vm.hills9)})})]),_c('animate-x',{staticClass:"absolute",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: 0,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: -205,
        rotate: 0,
        scale: 1,
        opacity: 1,
        duration: 1000
      }
    ],"triggerAt":0,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"w-screen h-screen bg-center bg-cover",style:({'background-image': ("url(" + _vm.horses10)})})]),_c('animate-x',{staticClass:"absolute origin-top",attrs:{"keyframes":[
      {
        translateX: 0,
        translateY: _vm.windowHeight,
        rotate: 0,
        scale: _vm.scaleFactorTxt,
        opacity: 1,
        duration: 0
      },
      {
        translateX: 0,
        translateY: _vm.windowHeight * .5,
        rotate: 0,
        scale: _vm.scaleFactorTxt,
        opacity: 1,
        duration: 200
      }
    ],"triggerAt":900,"deltaYcounter":_vm.deltaYcounter}},[_c('div',{staticClass:"text-center w-screen text-white"},[_c('p',{staticStyle:{"font-size":"24px"}},[_vm._v(" Part of improving the railway is making"),_c('br'),_vm._v(" sure we're efficient. ")]),_c('p',{staticClass:"mb-5",staticStyle:{"font-size":"24px"}},[_vm._v(" This means getting value out of every"),_c('br'),_vm._v(" pound of taxpayer's money, and"),_c('br'),_vm._v(" minimising wastage of material - such"),_c('br'),_vm._v(" as our tracks. ")]),_c('img',{staticClass:"mx-auto",attrs:{"src":_vm.greenArrows,"alt":"green arrows"}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }